import { cartService } from "@/api/cart";
import { CheckoutResponse, Customer, EventInfo, UpdateOrderResponse, UpdateOrderLineItem, PublicOrder, UTMParams } from "@/types";

export class CartState {

  constructor() {
  }

  async addTicket(eventId: string, eventInfo: Omit<EventInfo, 'zoneName' | 'zoneNameEs' | 'menuName' | 'menuNameEs'>, quantity: number, utm?: UTMParams): Promise<string | null> {
    const orderId = await cartService.addTicket(eventId, eventInfo, quantity, utm);
    return orderId;
  }

  async addProduct(productId: string, quantity: number): Promise<string | null> {
    const orderId = await cartService.addProduct(productId, quantity);
    return orderId;
  }

  async validateCode(eventId: string, date: string, timeSlot: string, code: string): Promise<{ valid: boolean; percentage: number; remainingUses: number }> {
    return cartService.validateCode(eventId, date, timeSlot, code);
  }

  async checkout(orderId: string, customer: Customer, language?: string, discountCode?: string): Promise<CheckoutResponse> {
    const checkoutResponse = await cartService.checkout(orderId, customer, language, discountCode);
    return checkoutResponse;
  }

  async update(orderId: string, orderLines: UpdateOrderLineItem[]): Promise<UpdateOrderResponse> {
    const updateResponse = await cartService.update(orderId, orderLines);
    return updateResponse;
  }

  async get(orderId: string, authToken: string): Promise<PublicOrder> {
    const order = await cartService.get(orderId, authToken);
    return order;
  }
}

let cartStateInstance: CartState | null = null;

export function getCartState(): CartState {
  if (!cartStateInstance) {
    cartStateInstance = new CartState();
  }
  return cartStateInstance;
}
